import { render, staticRenderFns } from "./ProductAuthorization.vue?vue&type=template&id=1abe1128&scoped=true"
import script from "./ProductAuthorization.vue?vue&type=script&lang=js"
export * from "./ProductAuthorization.vue?vue&type=script&lang=js"
import style0 from "./ProductAuthorization.vue?vue&type=style&index=0&id=1abe1128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abe1128",
  null
  
)

export default component.exports